export default function Footer() {
  return (
    <section className="fixed bottom-2 w-[100vw] text-center">
      <p className="font-sans text-slate-400 text-sm">
        &copy; Copyright 2025, All Rights Reserved by Toshihito Endo
      </p>
    </section>
  );
}
